import json from '../../appsettings.json'

const cognitoSection = json.ConnectionSettings.Cognito == "PRD_Cognito" ? json.Authentication.PRD_Cognito : json.Authentication.DEV_Cognito;

export default {
    AWSConfig: {
        Region: cognitoSection.Region,
        UserPoolId: cognitoSection.UserPoolId,
        ClientId: cognitoSection.ClientId,
        IdentityPoolId: cognitoSection.IdentityPoolId,
    }
}

